import { AppTheme } from '@backstage/core-plugin-api';
import {
  createUnifiedTheme,
  palettes,
  pageTheme as defaultPageThemes,
  UnifiedThemeOptions,
  UnifiedThemeProvider,
} from '@backstage/theme';

/**
 * Default Backstage themes with one override: documentation pages (the /docs
 * home and TechDocs reader) use the same header gradient as catalog pages
 * (Home/Images), instead of the distinct 'documentation' gradient.
 */
const withHomeDocsHeader = (palette: UnifiedThemeOptions['palette']) =>
  createUnifiedTheme({
    palette,
    pageTheme: {
      ...defaultPageThemes,
      documentation: defaultPageThemes.home,
    },
  });

const lightTheme = withHomeDocsHeader(palettes.light);
const darkTheme = withHomeDocsHeader(palettes.dark);

export const appThemes: AppTheme[] = [
  {
    id: 'light',
    title: 'Light',
    variant: 'light',
    Provider: ({ children }) => (
      <UnifiedThemeProvider theme={lightTheme} children={children} />
    ),
  },
  {
    id: 'dark',
    title: 'Dark',
    variant: 'dark',
    Provider: ({ children }) => (
      <UnifiedThemeProvider theme={darkTheme} children={children} />
    ),
  },
];
